import type { Role } from '../types'

export function canManageSites(role: Role): boolean {
  return role === 'rv_admin' || role === 'org_admin'
}

export function canManageMembers(role: Role): boolean {
  return role === 'rv_admin' || role === 'org_admin'
}

export function canAccessAdmin(role: Role): boolean {
  return role === 'rv_admin'
}

export function canAccessTeam(role: Role): boolean {
  return role === 'rv_admin' || role === 'org_admin'
}

export function canExportData(role: Role): boolean {
  return role === 'rv_admin' || role === 'org_admin' || role === 'export'
}
